export * from "./tabs-container";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-tabs-component/dist/containers/index.js
// module id = ./node_modules/angular-tabs-component/dist/containers/index.js
// module chunks = vendor